module.exports = __webpack_public_path__ + "img/B2B2C_distribution.0fce0753.png";